<template>
  <v-card class="mt-6">
    <v-expansion-panel :value="panelOpen ? [0] : []">
      <v-expansion-panel-content value="true">
        <template v-slot:header>
          <v-flex class="header">
            <h1 class="title -tongue">
              <strong>Filtros</strong>.
            </h1>
          </v-flex>
          <div @click="togglePanel" :class="{ 'active': panelOpen }">
          </div>
        </template>
        <v-layout
            justify-space-between
            column
        >
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4 class="ml-2 mr-2">
              <v-text-field ref="processNumber"
                            v-model="processNumber"
                            label="Número do Processo"
                            single-line></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md7 class="ml-2 mr-2">
              <v-text-field ref="personName"
                            v-model="personName"
                            label="Nome do Solicitante"
                            single-line></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 class="ml-2 mr-2">
              <v-text-field ref="personCpfCnpj"
                            v-model="personCpfCnpj"
                            :mask="personCpfCnpj.length >= 12 ? '##.###.###/####-##' : '###.###.###-###'"
                            label="CNPJ/CPF do Solicitante"
                            single-line>
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md7 class="ml-2 mr-2">
              <v-text-field ref="typology"
                            v-model="typology"
                            label="typology (Código ou Descrição)"
                            single-line></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4 class="ml-2 mr-2" >
              <v-select
                v-model="applicationType"
                :hint="'Selecione um Tipo de Requerimento'"
                :items="applicationTypesOptions"
                item-text="label"
                item-value="id"
                single-line
                label="Tipo de Requerimento">
              </v-select>
            </v-flex>
            <v-flex xs12 sm6 md4 class="ml-2 mr-2" >
              <v-select
                v-model="status"
                :hint="'Selecione um Status'"
                :items="statusOptions"
                item-text="label"
                item-value="id"
                :item-color="item => item.color"
                single-line
                label="Status">
                <template #item="{ item }">
                  <div class="d-flex align-items-center">
                    <v-icon :color="item.color" small>mdi-circle-medium</v-icon>
                    <span>{{ item.label }}</span>
                  </div>
                </template>
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-2">
            <v-flex xs4>
              <v-btn color="secondary" class="ml-2" @click="clearFilters" style="float: left">
                <v-icon left>mdi-broom</v-icon>
                <span class="text">Limpar Filtros</span>
              </v-btn>
            </v-flex>
            <v-flex xs4 class="ml-auto">
              <v-btn color="primary" class="ml-2 mr-5" @click="search()" style="float: right">
                <v-icon left>mdi-file-search-outline</v-icon>
                <span class="text">Pesquisar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
</template>
<script>
import ApplicationTypeService from "@/services/applications/configurations/ApplicationTypeService";

export default {
  name: 'ApplicationsFilter',
  data() {
    return {
      processNumber : '',
      typology : '',
      applicationTypes : [],
      statusOptions : [],
      applicationType : '',
      personCpfCnpj : '',
      personName : '',
      status : '',
      isLoaded: false,
      panelOpen: true,
    };
  },
  mounted() {
    this.loadApplicationTypes();
    this.loadStatusOptions()
  },
  computed: {
    applicationTypesOptions(){
      if(!this.applicationTypes){
        this.loadApplicationTypes();
      }
      return this.applicationTypes;
    }
  },
  methods: {
    clearFilters() {
      this.processNumber = '';
      this.typology = '';
      this.applicationType = '';
      this.personCpfCnpj = '';
      this.personName = '';
      this.status = '';
    },
    loadStatusOptions(){
      let badge = {
        'all': {
          text: 'TODOS', color: 'grey'
        },
        'waiting_to_be_sent': {
          text: 'AGUARDANDO ENVIO', color: 'grey'
        },
        'waiting_for_review': {
          text: 'EM ANÁLISE', color: 'amber'
        },
        'pending': {
          text: 'PENDENTE', color: 'red'
        },
        'done': {
          text: 'APROVADO', color: 'green'
        }
      };
      this.statusOptions = Object.keys(badge).map(key => {
        return {
          id: key,
          label: badge[key].text,
          color: badge[key].color
        };
      });
    },
    loadApplicationTypes() {
        ApplicationTypeService.fetchApplicationTypesSelectable().then(response => {
        const at = response.data;
        this.applicationTypes = at.map(item => {
          return {
            id: item.id,
            label: item.acronym + ' - ' + item.name,
          };
        });
        this.isLoaded = true;
      });
    },
    search(){
      this.validateBefore();

      if(this.$refs.processNumber.hasError ||
          this.$refs.personCpfCnpj.hasError ||
          this.$refs.personName.hasError ||
          this.$refs.typology.hasError){
        return;
      }
      this.personCpfCnpj = this.removeCaracteresEspeciais(this.personCpfCnpj);

      this.$emit('search', {
          processNumber: this.processNumber,
          status: this.status,
          personCpfCnpj: this.personCpfCnpj,
          personName: this.personName,
          applicationType: this.applicationType,
          typology: this.typology,
      });
    },
    removeCaracteresEspeciais(valor) {
      return valor.replace(/[^\d]+/g,'')
    },

    validateBefore(){
      if(this.processNumber.length > 0){
        this.$refs.processNumber.validate();
      }
      if(this.personCpfCnpj.length > 0){
        this.$refs.personCpfCnpj.validate();
      }
      if(this.personName.length > 0){
        this.$refs.personName.validate();
      }

    },
    togglePanel() {
      this.panelOpen = !this.panelOpen;
    },
    applyFilters() {
      // TODO: Implement filter logic here
    },
  },
};
</script>
<style lang="scss" scoped>
.header{
  margin-left: 40px;
}
.badge {
  color: #fff;

  &.waiting_to_be_sent{
    background: #616161;
  }
  &.waiting_for_review{
    background: #ffc107;
  }
  &.pending, &.intimated{
    background: #f44336;
  }
  &.done{
    background: #4caf50;
  }

}

</style>

